import styles from "./OnboardingStyles.module.css"
import { useState } from 'react';
import PrimaryButton from "../Button/PrimaryButton/PrimaryButton";
import { StepFormProps } from "../../types/onboarding.types";
import SecondaryButton from "../Button/SecondaryButton/SecondaryButton";
import OnboardingPopup from "./OnboardingPopup";
import { useTranslation } from "react-i18next";
/**
* Onboarding step.
*
* @param props StepFormProps
* @param {(step: number) => void} props.setStep - Step change handler
* @param {number} props.currentStep - Current step
* @param {OnboardingFormData} props.formData - Onboarding data
* @param {React.Dispatch<React.SetStateAction<OnboardingFormData>>} props.setFormData - Onboarding data change handler
* @param {() => void} props.clearData - Clear data handler
* @returns TSX.Element
*/
const Step7Form = ({currentStep, setStep, onPopup}:StepFormProps) => {
    const { t } = useTranslation(); // Translation
    const optionList = [t("onboarding.steps.7.buttons.furniture"), t("onboarding.steps.7.buttons.photographer"), t("onboarding.steps.7.buttons.recording"), t("onboarding.steps.7.buttons.coctail_show")] // Sample extras
    const [popupOpen, setPopupOpen] = useState<boolean>(false) // Popup display state

    const handleLargeAction = () => {
        // redirect to email or smth
        alert("vytvorena poptavka")
    };
    // Popup open logic
    const handleSelection = () =>{
        setPopupOpen(true)
    }
    // Handle part skip
    const handleSkip = ()=>{
        setStep(currentStep+1)
    }
    
    return(
        <>
        {/*Large action popup */}
        <OnboardingPopup
            titleKey="onboarding.steps.7.popup.title"
            contentKey="onboarding.steps.7.popup.content"
            display={popupOpen}
            onClose={() => setPopupOpen(false)}
            onSubmit={() => handleLargeAction()}
            onPopup={onPopup}
        />
        <div className={styles.OnboardingContent}>
            <div className={styles.Container}>
                <div className={styles.SecondaryTitle}>
                    <p>{t("onboarding.steps.7.title")}</p>
                </div>
                <div className={styles.ChoiceButtons}>
                    {optionList.map(option => (
                        <SecondaryButton onClick={()=>handleSelection()} text={option} key={option} className={styles.ChoiceButtonRound} showChevron={false} colorVariant="primary"/>
                    ))}
                </div>
                <div  className={styles.ContinueButton}>
                    <SecondaryButton text={t("onboarding.steps.7.dismiss")} colorVariant="neutral" onClick={()=>handleSkip()} showChevron={false}/>
                    <PrimaryButton onClick={()=>setStep(currentStep+1)} text={t("buttons.proceed")}/>
                </div>
            </div>
        </div>
        </>
    )
};

export default Step7Form;
